import { Component } from '@angular/core';

@Component({
  selector: 'wk8-book-text',
  imports: [],
  templateUrl: './wk8-book-text.component.html',
  styleUrl: './wk8-book-text.component.css',
})
export class Wk8BookTextComponent {}
